import React, { Fragment } from 'react';
import { withCookies } from 'react-cookie';
import stripebadge from '../assets/stripebadge.png';

import { Typography, Paper, Button } from '@material-ui/core'

import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

import { RestComponent, StripeManager } from 'react-frontend-utils'


/**
 * 
 * Checkout Component when Payment button is clicked
 * 
 * The caller must pass the props:
 * 
 * returnToAccount:        a function to be called to go back to the Accounts page
 * paymentComplete:        callback function when charging succeeds
 * paymentDescription:     String describing the payment (for instance the amount)
 * clientSecret:           the clientSecret retrieved from the backend from Stripe
 * email:                  pre-populate the email for the credit card
 * disabled:               disable when user hasn't consented to the terms and conditions
 * 
 * The StripeManager component takes care of the purchase. 
 *
 */


export class PaymentCheckout extends RestComponent {

    styles = {
        paperLabel: {
            color: 'blue',
            fontSize: '12pt',
            flexGrow: 1
        }
    }


    render() {
        
        return (
            <Fragment>

                {this.getConfirmAlertComponent()}

                <Paper style={{padding: 20}}>

                    <Typography variant="h6" align='center' style={{marginBottom: 40}}>{this.props.paymentDescription}</Typography>                           

                    <Button color="primary" style={{marginBottom: 20}} onClick={this.props.returnToAccount}>
                        <ArrowBackIosIcon fontSize='small'/> 
                        <Typography variant="body1">Cancel and Go Back to Account</Typography>   
                    </Button>  

                    {this.props.disabled ? 
                        <Typography variant="body1" align='center' style={{fontStyle: 'italic'}}>Please consent to the terms and conditions to enable payment</Typography>  
                        :
                        <StripeManager email={this.props.email}
                                        clientSecret={this.props.clientSecret}
                                        paymentSuccess={this.props.paymentComplete}/>
                    }
                </Paper>

                <div style={{display: 'flex', justifyContent: 'center', marginTop: 100}}>

                    <a href="https://www.stripe.com" target="_blank" rel="noopener noreferrer">
                        {<img src={stripebadge} alt="stripe badge" width='400px'/>}
                    </a>

                </div>                

            </Fragment>
        );
    }

}

export default withCookies(PaymentCheckout);
